import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {RegularPanel} from './EmbededPanel.react';
import urlMapping from '../app/URLMapping';
import EventTracker from '../app/EventTracker';
import {FormattedMessage} from 'react-intl';

class InternalError extends React.Component {

	static contentStyle = {
		margin: 'auto 0'
	};

    static propTypes = {
        location: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    static contextTypes = {
        embededPanelController: PropTypes.object,
        router: PropTypes.object,
    };

    constructor(props) {
        super(props);

        EventTracker.initEventTracker(props.user);
    }

    componentWillUnmount() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    switchToSmall() {
        let urlObject = this.context.embededPanelController.getURLObject();
        let path = urlMapping.getUrl("panel", "error-mini", urlObject);
        this.context.router.push(path);
    }

    close = () => {
        this.switchToSmall();
    };

    render() {
        return (
            <RegularPanel close={this.close} hideMenu typeForTest="internal-error">
                <div className="bordered-content">
                    <div className="embedLoading">
                        <div style={InternalError.contentStyle}><i aria-hidden="true" className="fa fa-exclamation-triangle fa-3x fa-fw margin-bottom" style={{color: '#d2322d'}} ></i></div>

                        <div style={InternalError.contentStyle}>
                            <div style={{paddingTop: '9px'}}><strong><FormattedMessage defaultMessage="Network Error" id="error.network" /></strong></div>
							<p><FormattedMessage defaultMessage="Check your internet connection and reload the browser." id="error.networkDescription" /></p>
                        </div>
                    </div>
                </div>
            </RegularPanel>
        );
    }
}

export default Relay.createContainer(InternalError, {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => {
            return Relay.QL`
                fragment on User {
                    id,
                    realId,
                    ${EventTracker.getFragment()}
                }`;
        }
    },


});
